export enum PageType {
    WELCOME,
    PHONE,
    PHONE_VERIFICATION,
    EMAIL,
    DESTINATION,
    REDEEMED
}
